export const RESET_STATE = 'RESET_STATE';

export const resetStateAction = (payload) => ({
    type: RESET_STATE,
    payload
  });